import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import timLama from "../../Assets/tim-lama.jpeg";

const PdfBpb = ({ data, qrApprover, qrRequestor }) => {
  let dataPdf = data && data;

  let qrApproverTemp = qrApprover && qrApprover;
  let qrRequestorTemp = qrRequestor && qrRequestor;

  const styles = StyleSheet.create({
    section: {
      padding: "18px",
    },
    headerImage: {
      width: "36px",
      height: "36px",
      marginRight: "6px",
    },
    mantap: {
      flexDirection: "row",
      alignItems: "center",
    },
    jiwa: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "12px",
    },
    headerTable: {
      flexDirection: "row",
      width: "100%",
    },
    headerAngka: {
      width: "10%",
      border: "1px solid black",
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.section}>
        <View style={styles.jiwa}>
          <Text style={{ fontSize: "14px" }}>Form-PUR-A3-R2</Text>
        </View>
        <View style={styles.jiwa}>
          <View style={styles.mantap}>
            <Image src={timLama} style={styles.headerImage} />
            <Text style={{ fontSize: "14px", textDecoration: "underline" }}>
              Bon Permintaan Barang dan Jasa (BPB)
            </Text>
          </View>
        </View>
        <View style={styles.jiwa}>
          <Text style={{ fontSize: "12px" }}>No: {dataPdf.bpbNumber}</Text>
          <Text style={{ fontSize: "12px" }}>
            Tgl:{" "}
            {moment(dataPdf.date)
              .utcOffset("+0700")
              .format("DD MMM YYYY, HH:mm:ss")}
          </Text>
          <Text style={{ fontSize: "12px" }}>Dari: {dataPdf.dari}</Text>
          <Text style={{ fontSize: "12px" }}>Ke: {dataPdf.ke}</Text>
        </View>

        <View style={styles.headerTable}>
          <Text
            style={{
              width: "4%",
              border: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            No.
          </Text>
          <Text
            style={{
              width: "35%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Item
          </Text>
          <Text
            style={{
              width: "8%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Jumlah
          </Text>
          <Text
            style={{
              width: "10%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Satuan
          </Text>
          <Text
            style={{
              width: "23%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Keterangan
          </Text>
          <Text
            style={{
              width: "10%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Estimasi
          </Text>
          <Text
            style={{
              width: "10%",
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              fontSize: "11px",
              padding: "6px 4px",
            }}
          >
            Realisasi
          </Text>
        </View>

        {dataPdf.items.map((ele, index) => {
          return (
            <View style={styles.headerTable}>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "4%",
                        borderBottom: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "4%",
                        borderBottom: "1px solid black",
                        borderLeft: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {index + 1}.
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "35%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "35%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele.item}
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "8%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "8%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele.jumlah}
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele.satuan}
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "23%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "23%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele.keterangan}
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele && ele.estimasi
                  ? moment(ele && ele.estimasi)
                      .utcOffset("+0700")
                      .format("DD-MM-YY")
                  : ""}
              </Text>
              <Text
                style={
                  ele.isBeli
                    ? {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                      }
                    : {
                        width: "10%",
                        borderBottom: "1px solid black",
                        borderRight: "1px solid black",
                        fontSize: "9px",
                        padding: "6px 4px",
                        backgroundColor: "red",
                        color: "white",
                      }
                }
              >
                {ele && ele.realisasiDate
                  ? moment(ele && ele.realisasiDate)
                      .utcOffset("+0700")
                      .format("DD-MM-YY")
                  : ""}
              </Text>
            </View>
          );
        })}
        <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
          <View style={{ marginTop: "12px" }}>
            <Text style={{ fontSize: "12px", marginBottom: "4px" }}>
              Catatan:
            </Text>

            {dataPdf.items
              .map((item, index) => ({
                ...item,
                no: index + 1,
              }))
              .filter((item) => item.catatan && item.catatan.trim() !== "")
              .map((item, index) => (
                <Text
                  key={index}
                  style={{
                    fontSize: "10px",
                    marginBottom: "2px",
                  }}
                >
                  {item.no}. {item.catatan}
                </Text>
              ))}

            {/* kalau tidak ada catatan */}
            {dataPdf.items.filter(
              (item) => item.catatan && item.catatan.trim() !== ""
            ).length === 0 && <Text style={{ fontSize: "10px" }}>-</Text>}
          </View>
          <View style={{ flexDirection: "row", marginTop: "12px" }}>
            <View style={{ marginRight: "36px" }}>
              <Text
                style={{
                  fontSize: "12px",
                }}
              >
                Menyetujui,
              </Text>
              <Image src={qrApproverTemp} style={{ width: 96, height: 96 }} />
              <Text style={{ marginRight: "12px", fontSize: "12px" }}>
                {dataPdf.approver}
              </Text>
            </View>
            <View>
              <Text
                style={{
                  marginRight: "12px",
                  fontSize: "12px",
                }}
              >
                Pemohon,
              </Text>
              <Image src={qrRequestorTemp} style={{ width: 96, height: 96 }} />
              <Text style={{ marginRight: "12px", fontSize: "12px" }}>
                {dataPdf.requestor.split(" ").slice(0, 2).join(" ")}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default PdfBpb;
